import React, { useEffect, useState } from 'react';
import AdminLayout from '../components/Layout/AdminLayout';
import { toast } from 'react-toastify';
import { fetchVerifiedOrders, fetchOrderById } from '../api/api'; 
// @ts-ignore
import 'react-toastify/dist/ReactToastify.css';
import { 
    FaEdit, FaTruck, FaTimesCircle, FaMapMarkerAlt, FaClock, 
    FaInfoCircle, FaExclamationTriangle, FaPaperPlane, FaEye,
    FaUser, FaPhone, FaBoxOpen, FaStore, FaRupeeSign, FaChevronDown
} from 'react-icons/fa'; 
import { useNavigate } from 'react-router-dom';

export interface Order {
    id: string;
    orderId?: string;
    waybill?: string; 
    deliveryPartner?: string; // ✅ NAYA FIELD ADD KIYA
    customerName?: string;
    mobile?: string;
    medicine?: string;
    medicinePrice?: number;
    medicineUnit?: string;
    medicineQuantity?: number;
    payableAmount?: number;
    status?: string;
    sellerUsername?: string;
    alternateMobile?: string;
    houseNumber?: string;
    streetArea?: string;
    landmark?: string;
    city?: string;
    state?: string;
    pincode?: string;
    country?: string;
    mainUser?: {
        firstName: string;
        lastName?: string;
        mobile?: string;
    };

    shipmentStatus?: string;
shipment_status?: string;
deliveredAt?: string;
delivered_at?: string;
trackingError?: string;
tracking_error?: string;
}

// --- Order Detail Modal ---
const OrderDetailsModal: React.FC<{ order: Order; onClose: () => void }> = ({ order, onClose }) => {
    const fName = order.mainUser?.firstName || '';
    const lName = order.mainUser?.lastName || '';
    const nameDisplay = fName ? `${fName} ${lName}` : 'Unknown Customer';
    const mobileDisplay = order.mainUser?.mobile || order.mobile || 'N/A';
    
    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-3xl overflow-hidden flex flex-col max-h-[90vh]">
                <div className="bg-emerald-600 p-5 flex justify-between items-center text-white">
                    <div className="flex items-center gap-3">
                        <div className="bg-white/20 p-2 rounded-lg">
                           <FaBoxOpen size={20} />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold">Order Details (Verified)</h2>
                            <p className="text-xs text-emerald-100 opacity-80">ID: {order.id}</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors">
                        <FaTimesCircle size={22}/>
                    </button>
                </div>

                <div className="p-6 overflow-y-auto custom-scrollbar space-y-6">
                    <div className="bg-emerald-50 dark:bg-gray-800/50 p-4 rounded-xl border border-emerald-100 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-4">
                        <div>
                            <span className="text-sm text-gray-500 dark:text-gray-400">Product Name</span>
                            <h3 className="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-2">
                                {order.medicine}
                                <span className="text-xs bg-emerald-200 dark:bg-emerald-900 text-emerald-700 dark:text-emerald-300 px-2 py-0.5 rounded-full">
                                    Qty: {order.medicineQuantity}
                                </span>
                            </h3>
                        </div>
                        <div className="text-right">
                            <span className="text-sm text-gray-500 dark:text-gray-400">Total Amount</span>
                            <h3 className="text-2xl font-bold text-green-600 dark:text-green-400 flex items-center">
                                <FaRupeeSign size={18}/> {order.payableAmount}
                            </h3>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-6">
                            <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-xl">
                                <h4 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                                    <FaUser className="text-emerald-500"/> Customer Info
                                </h4>
                                <div className="space-y-2">
                                    <p className="text-gray-900 dark:text-gray-100 font-medium">{nameDisplay}</p>
                                    <p className="text-gray-600 dark:text-gray-300 text-sm flex items-center gap-2">
                                        <FaPhone size={12} className="text-gray-400"/> {mobileDisplay}
                                    </p>
                                    {order.alternateMobile && (
                                        <p className="text-gray-500 text-xs pl-5">Alt: {order.alternateMobile}</p>
                                    )}
                                </div>
                            </div>

                            <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-xl">
                                <h4 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                                    <FaStore className="text-orange-500"/> Seller Info
                                </h4>
                                <div className="space-y-2">
                                    <p className="text-gray-900 dark:text-gray-100 font-medium">
                                        {order.sellerUsername ? `@${order.sellerUsername}` : 'Direct/Admin Sale'}
                                    </p>
                                    <span className="text-xs px-2 py-1 rounded border bg-orange-100 text-orange-700 border-orange-200">
                                        {order.waybill ? `Waybill: ${order.waybill}` : 'Awaiting Shipment'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-xl h-full">
                            <h4 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3 flex items-center gap-2">
                                <FaMapMarkerAlt className="text-red-500"/> Shipping Address
                            </h4>
                            <div className="text-gray-700 dark:text-gray-300 text-sm space-y-1 leading-relaxed">
                                <p className="font-medium">{order.houseNumber}</p>
                                <p>{order.streetArea}</p>
                                {order.landmark && <p className="text-gray-500 italic">Near {order.landmark}</p>}
                                <p>{order.city}, {order.state}</p>
                                <p className="font-bold text-gray-900 dark:text-white tracking-wide pt-1">PIN: {order.pincode}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-4 bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-lg text-gray-800 dark:text-white transition text-sm font-medium">
                        Close Details
                    </button>
                </div>
            </div>
        </div>
    );
};

const VerifiedOrders: React.FC = () => {
    const [orders, setOrders] = useState<Order[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [isAgent, setIsAgent] = useState<boolean>(false);
    const [shippingOrderId, setShippingOrderId] = useState<string | null>(null);
    const navigate = useNavigate();

    // Multiple Delivery States
    const [selectedPartners, setSelectedPartners] = useState<Record<string, string>>({});

    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedOrderDetails, setSelectedOrderDetails] = useState<Order | null>(null);

    // Tracking States
    const [trackModalOpen, setTrackModalOpen] = useState<boolean>(false);
    const [trackLoading, setTrackLoading] = useState<boolean>(false);
    const [trackData, setTrackData] = useState<any>(null);
    const [isShippingBulk, setIsShippingBulk] = useState<boolean>(false);

    // Role Check
    useEffect(() => {
        const checkUserRole = () => {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const base64Url = token.split('.')[1];
                    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join(''));
                    const payload = JSON.parse(jsonPayload);
                    if (JSON.stringify(payload).toUpperCase().includes('AGENT')) {
                        setIsAgent(true);
                    }
                }
            } catch (e) { console.error("Error decoding token", e); }
        };
        checkUserRole();
    }, []);

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const response = await fetchVerifiedOrders();
            setOrders(response.data);
        } catch (err) {
            setError('Failed to fetch verified orders.');
        } finally { setLoading(false); }
    };

    useEffect(() => { fetchOrders(); }, []);

    const handleView = async (orderId: string) => {
        try {
            const response = await fetchOrderById(orderId);
            setSelectedOrderDetails(response.data as any);
            setIsModalOpen(true);
        } catch (e) { toast.error("Details fetch failed"); }
    };

    // Updated with partner parameter and fixed Endpoint URL
    const handleShipOrder = async (orderId: string) => {
        const partner = selectedPartners[orderId] || 'DELHIVERY'; 
        setShippingOrderId(orderId);
        try {
            const token = localStorage.getItem('token');
            
            // ✅ Fix URL: /api/orders/admin/ship-order/ (Kyunki backend mein OrderController par @RequestMapping("/api/orders") hai)
            const url = `https://www.ayushvatika.com/api/admin/ship-order/${orderId}?partner=${partner}`;
            // const url = `http://localhost:8484/api/orders/admin/ship-order/${orderId}?partner=${partner}`;
            
            const res = await fetch(url, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (res.status === 402) {
                toast.error(
                    <div className="flex flex-col gap-1 p-1">
                        <span className="font-bold flex items-center gap-2 text-red-700">
                            <FaExclamationTriangle /> {partner} Balance Low!
                        </span>
                        <p className="text-xs text-gray-700 leading-normal">
                            Check your wallet balance for {partner}.
                        </p>
                    </div>,
                    { position: "top-center", autoClose: 10000 }
                );
                return;
            }

            const data = await res.text();
            if (res.ok) {
                toast.success(`Shipment Success with ${partner}!`);
                fetchOrders(); 
            } else {
                toast.error(`Error: ${data}`);
            }
        } catch (e) {
            toast.error("Server Connection Error.");
        } finally {
            setShippingOrderId(null);
        }
    };

    const handleShipAll = async () => {
        const pending = orders.filter(o => !o.waybill);
        if (pending.length === 0) return toast.info("No orders to ship.");
        if (!window.confirm(`Ship all ${pending.length} orders?`)) return;
        setIsShippingBulk(true);
        for (const order of pending) { await handleShipOrder(order.id); }
        setIsShippingBulk(false);
    };

    // Tracking URL Updated to include partner and point to localhost
  const handleTrack = async (waybill?: string, partner?: string) => {
    if (!waybill) return toast.warning("Order not shipped yet.");

    setTrackModalOpen(true);
    setTrackLoading(true);

    try {
        const token = localStorage.getItem('token');
        const targetPartner = partner || 'DELHIVERY';

        const trackUrl = `https://www.ayushvatika.com/api/delivery/track?partner=${targetPartner}`;
        // const trackUrl = `http://localhost:8484/api/delivery/track?partner=${targetPartner}`;

        const response = await fetch(trackUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ waybill })
        });

        const data = await response.json();

        // API failed ho to rawResponse parse mat karo
        if (data?.success === false) {
            setTrackData({
                waybill,
                status: data.currentStatus || 'TRACKING_FAILED',
                instructions: data.error || 'Tracking unavailable from courier API',
                location: `${targetPartner} API`,
                time: data.statusDateTime || new Date().toLocaleString()
            });
            return;
        }

        // Backend clean status de raha hai
        if (data?.success === true && data?.currentStatus) {
            let instructions = 'Tracking updated successfully';
            let location = targetPartner;

            if (data.rawResponse) {
                try {
                    const raw = JSON.parse(data.rawResponse);
                    const statusObj = raw?.ShipmentData?.[0]?.Shipment?.Status || {};

                    instructions = statusObj.Instructions || instructions;
                    location =
                        statusObj.StatusLocation ||
                        statusObj.ScannedLocation ||
                        location;
                } catch (e) {
                    // Raw parse fail ho to clean backend status use hoga
                }
            }

            setTrackData({
                waybill,
                status: data.currentStatus,
                instructions,
                location,
                time: data.statusDateTime || new Date().toLocaleString()
            });
            return;
        }

        setTrackData({
            waybill,
            status: 'UNKNOWN',
            instructions: 'No tracking details found',
            location: targetPartner,
            time: new Date().toLocaleString()
        });

    } catch (err) {
        toast.error("Tracking error.");
        setTrackModalOpen(false);
    } finally {
        setTrackLoading(false);
    }
};

    return (
        <AdminLayout>
            <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-200">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4">
                    <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Verified Orders</h1>
                    {!isAgent && (
                        <button 
                            onClick={handleShipAll}
                            disabled={isShippingBulk || orders.filter(o => !o.waybill).length === 0}
                            className="bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-lg font-bold shadow-md flex items-center justify-center gap-2 transition-all disabled:opacity-50"
                        >
                            {isShippingBulk ? "Shipping..." : <><FaPaperPlane /> Bulk Ship All</>}
                        </button>
                    )}
                </div>
                
                <div className="overflow-x-auto custom-scrollbar bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="bg-gray-50 dark:bg-gray-700">
                            <tr>
                                <th className="py-3 px-4 text-left text-xs text-gray-500 uppercase">Order Details</th>
                                <th className="py-3 px-4 text-left text-xs text-gray-500 uppercase">Customer</th>
                                <th className="py-3 px-4 text-left text-xs text-gray-500 uppercase">Product</th>
                                <th className="py-3 px-4 text-right text-xs text-gray-500 uppercase">Amount</th>
                                <th className="py-3 px-4 text-center text-xs text-gray-500 uppercase">Delivery status</th>
                                <th className="py-3 px-4 text-center text-xs text-gray-500 uppercase">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                            {orders.map((order) => {
                                const cName = order.mainUser ? `${order.mainUser.firstName} ${order.mainUser.lastName || ''}` : 'Unknown';
                                return (
                                    <tr key={order.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                                        <td className="py-3 px-4 text-sm">
                                            <div className="font-mono text-gray-600 dark:text-gray-400 font-bold">#{order.id.substring(0, 6)}</div>
                                            <div className="text-[10px] text-gray-400">Seller: {order.sellerUsername || 'Admin'}</div>
                                        </td>
                                        <td className="py-3 px-4 text-sm font-medium">
                                            <div className="text-gray-900 dark:text-white">{cName}</div>
                                            <div className="text-gray-500 text-xs">{order.mainUser?.mobile}</div>
                                        </td>
                                        <td className="py-3 px-4 text-sm">
                                            <div className="text-gray-800 dark:text-gray-200">{order.medicine}</div>
                                            <div className="text-[10px] text-gray-500">Qty: {order.medicineQuantity}</div>
                                        </td>
                                        <td className="py-3 px-4 text-right font-bold text-green-600">₹{order.payableAmount?.toFixed(0)}</td>
                                        
                                        <td className="py-3 px-4 text-center">
                                            {order.waybill ? (
                                                <div className="flex flex-col items-center">
                                                    <span className="bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400 text-xs font-bold px-2 py-1 rounded border border-green-200 dark:border-green-800 mb-1">
                                                        WB: {order.waybill}
                                                        {(order.shipmentStatus || order.shipment_status) && (
    <span className="text-[10px] font-bold text-green-600 dark:text-green-400">
        Status: {(order.shipmentStatus || order.shipment_status)?.replaceAll('_', ' ')}
    </span>
)}
                                                    </span>
                                                    <span className="text-[10px] font-bold text-blue-600 dark:text-blue-400">
                                                        By {order.deliveryPartner || 'DELHIVERY'}
                                                    </span>
                                                </div>
                                            ) : isAgent ? (
                                                <span className="text-gray-400 text-xs italic">Waiting for Admin</span>
                                            ) : (
                                                <div className="flex flex-col items-center gap-1">
                                                    <div className="relative group">
                                                        <select 
                                                            className="appearance-none bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-[10px] rounded px-2 py-1 pr-6 cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-500"
                                                            value={selectedPartners[order.id] || 'DELHIVERY'}
                                                            onChange={(e) => setSelectedPartners({
                                                                ...selectedPartners,
                                                                [order.id]: e.target.value
                                                            })}
                                                        >
                                                            <option value="DELHIVERY">Delhivery</option>
                                                            <option value="SHIPROCKET">Shiprocket</option>
                                                            <option value="EKART">Ekart</option>
                                                        </select>
                                                        <FaChevronDown className="absolute right-1.5 top-2 text-gray-400 pointer-events-none" size={8} />
                                                    </div>
                                                    <button 
                                                        onClick={() => handleShipOrder(order.id)}
                                                        disabled={shippingOrderId === order.id}
                                                        className="bg-blue-600 hover:bg-blue-700 text-white text-[10px] font-bold px-3 py-1.5 rounded shadow-sm transition-all flex items-center gap-1 mx-auto"
                                                    >
                                                        {shippingOrderId === order.id ? "Processing..." : "Ship Now"}
                                                    </button>
                                                </div>
                                            )}
                                        </td>

                                        <td className="py-3 px-4 text-center">
                                            <div className="flex justify-center gap-2">
                                                <button onClick={() => handleView(order.id)} className="p-2 bg-blue-600 hover:bg-blue-500 rounded text-white shadow-sm" title="View Details">
                                                    <FaEye size={14} />
                                                </button>

                                                <button onClick={() => handleTrack(order.waybill, order.deliveryPartner)} disabled={!order.waybill} className={`p-2 rounded shadow-sm ${order.waybill ? 'bg-indigo-600 text-white' : 'bg-gray-200 text-gray-400'}`}>
                                                    <FaTruck size={14} />
                                                </button>
                                                {!isAgent && !order.waybill && (
                                                    <button onClick={() => navigate(`/admin/update-order/${order.id}`)} className="p-2 bg-yellow-500 text-white rounded shadow-sm">
                                                        <FaEdit size={14} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODALS */}
            {isModalOpen && selectedOrderDetails && <OrderDetailsModal order={selectedOrderDetails} onClose={() => setIsModalOpen(false)} />}

            {trackModalOpen && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
                    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn">
                        <div className="bg-indigo-600 p-4 flex justify-between text-white">
                            <h2 className="font-bold flex items-center gap-2"><FaTruck /> Live Track</h2>
                            <button onClick={() => setTrackModalOpen(false)}><FaTimesCircle size={20}/></button>
                        </div>
                        <div className="p-6">
                            {trackLoading ? (
                                <div className="text-center py-8">
                                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
                                    <p className="mt-4 text-sm text-gray-500">Checking...</p>
                                </div>
                            ) : trackData ? (
                                <div className="space-y-4">
                                    <div className="text-xl font-bold text-gray-900 dark:text-white border-b pb-2">{trackData.status}</div>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">{trackData.instructions}</p>
                                    <div className="text-xs text-gray-500 flex flex-col gap-1">
                                        <span className="flex items-center gap-1"><FaMapMarkerAlt /> {trackData.location}</span>
                                        <span className="flex items-center gap-1"><FaClock /> {trackData.time}</span>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
};

export default VerifiedOrders;